export default __webpack_public_path__ + "static/media/sennheisser_logo_menu.27420ebf.svg";